var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfNoPage"},[(_vm.isLoading)?_c('div',{staticClass:"mask"},[_c('loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("加载中...")])],1):_vm._e(),_c('div',{staticClass:"pdf-box"},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,attrs:{"src":_vm.pdfSrc,"page":i},on:{"page-loaded":_vm.pageLoaded}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }